import React from 'react';
import InputPercentForm from '../../../../../components/form/InputPercentForm';
import SwitchForm from '../../../../../components/form/SwitchForm';
import {
  PRODUCT_MANAGEMENT_TYPE_TEXT,
  PRODUCT_MANAGEMENT_TYPE,
} from '../../../../../constants/service/app/productConstants';
import { setDash } from '../../../../../lib/common';
import { setFeeMaximumNumber } from '../../../../../lib/utils/commonUtils';
import { formRequiredRules } from '../../../../../lib/formRules';

const columns = (data) => {
  const { form, isEditable, listName, setData } = data;

  return [
    {
      title: '타입',
      dataIndex: 'type',
      render: (value) => setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[value]),
    },
    {
      title: 'PG 수수료',
      dataIndex: 'isPgFee',
      render: (value, record, index) => (
        <SwitchForm
          checked={value}
          disabled={!isEditable || record.type === PRODUCT_MANAGEMENT_TYPE.PURCHASE}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', listName, index, 'isPgFee'],
              value,
            })
          }
        />
      ),
    },
    {
      title: '아몬즈 수수료',
      dataIndex: 'amondzFeeRate',
      render: (value, record, index) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          max={setFeeMaximumNumber([record.marketingFeeRate, record.fulfillmentFeeRate])}
          initialValue={value}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', listName, index, 'amondzFeeRate'],
              value,
            })
          }
          name={`${listName}_amondzFeeRate_${record.id}`}
        />
      ),
    },
    {
      title: '마케팅 수수료',
      dataIndex: 'marketingFeeRate',
      render: (value, record, index) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          max={setFeeMaximumNumber([record.amondzFeeRate, record.fulfillmentFeeRate])}
          initialValue={value}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', listName, index, 'marketingFeeRate'],
              value,
            })
          }
          name={`${listName}_marketingFeeRate_${record.id}`}
        />
      ),
    },
    {
      title: '풀필먼트 수수료',
      dataIndex: 'fulfillmentFeeRate',
      render: (value, record, index) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          initialValue={value}
          max={setFeeMaximumNumber([record.amondzFeeRate, record.marketingFeeRate])}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', listName, index, 'fulfillmentFeeRate'],
              value,
            })
          }
          name={`${listName}_fulfillmentFeeRate_${record.id}`}
        />
      ),
    },
  ];
};

export default columns;
